import { useEffect } from "react";

export function useMountEffect(func) {
  useEffect(() => {
    func();
    // eslint-disable-next-line
  }, []);
}
